export default "__VITE_ASSET__BrsbFgbd__"